export default __webpack_public_path__ + "assets/warning-945e2c6927899e2d67efe29ae4e1f47b.svg";